var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 4.99959V12.9998C13.5003 13.276 13.2764 13.4998 13.0003 13.4998H5.00009C4.72395 13.4998 4.50009 13.276 4.50009 12.9998V9.99998C4.50009 9.72384 4.72394 9.49999 5.00008 9.49998L8.00003 9.49992C8.82844 9.49991 9.5 8.82834 9.5 7.99992V4.99953C9.5 4.72338 9.72386 4.49953 10 4.49953L13.0003 4.49959C13.2765 4.49959 13.5003 4.72345 13.5003 4.99959Z",
    fill: "#3DA5E8",
    stroke: "#3DA5E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.5H9.00019C9.27634 0.5 9.50019 0.723864 9.50019 1.00001L9.50013 4.0001C9.50012 4.27625 9.27626 4.5001 9.00011 4.50009L5.99995 4.50002C5.1715 4.5 4.4999 5.1716 4.49992 6.00005L4.49998 9.00011C4.49998 9.27625 4.27613 9.50011 3.99999 9.50012L1.00001 9.50019C0.723865 9.50019 0.5 9.27633 0.5 9.00019V1C0.5 0.723858 0.723857 0.5 1 0.5Z",
    fill: "#0073BC",
    stroke: "#0073BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquare);
export default __webpack_public_path__ + "static/media/icon-square.1a6a65d8a0da60114ccb27feec0bb866.svg";
export { ForwardRef as ReactComponent };